"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_video(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a5a5123a-05b0-48cd-b4bf-cd431685d236",
    x1: 131.97,
    y1: 84.24,
    x2: 175.16,
    y2: 127.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "video-hi"), /*#__PURE__*/React.createElement("g", {
    id: "329c6de2-4104-4993-bbbe-48c515ac632d",
    "data-name": "video-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "77a59121-2ec9-405a-85f3-614ff73fd485",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c2ede347-81e4-479a-8d02-06a7098354d7",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "40315890-148f-4d02-b1df-6eb3d93d1c45",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d0e86ce0-4413-4940-a5e1-b69fb45b47b6",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0ab906db-8c79-4751-9d3b-bff1e2248902",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0e718ea3-ff2f-4ec6-bf0a-81768e307fb6",
    "data-name": "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "61cca113-5046-4f37-97f5-09040b8d1332",
    "data-name": "User_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4a0c2a53-862d-47b4-aa97-04313c5300be",
    "data-name": "Video_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149,87.62",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fecb00",
    strokeLinejoin: "round",
    strokeWidth: 8.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.42,130.21,144,120V72.17l20.39-10.3A8,8,0,0,1,176,69v54.05A8,8,0,0,1,164.42,130.21Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.42,130.21,144,120V72.17l20.39-10.3A8,8,0,0,1,176,69v54.05A8,8,0,0,1,164.42,130.21Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.27,72.29l-.4,48.11h.5l20.22,9.93a8,8,0,0,0,11.53-7.18V105.8A4,4,0,0,0,175,103Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#a5a5123a-05b0-48cd-b4bf-cd431685d236)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.42,128.21,144,118v2l20.42,10.21A8,8,0,0,0,176,123.06v-2A8,8,0,0,1,164.42,128.21Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.05,
    y: 48,
    width: 127.95,
    height: 96,
    rx: 16,
    ry: 16,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.89,
    y: 117,
    width: 63.83,
    height: 3.99,
    rx: 1.99,
    ry: 1.99,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 72,
    r: 6,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,142H32a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h96a16,16,0,0,0,16-16v-2A16,16,0,0,1,128,142Z",
    transform: "translate(0 0)",
    opacity: 0.06
  })))))))))));
}

var _default = ic_video;
exports.default = _default;